import { FormulaSpec } from '../object/field-formula-side-sheet/field-formula-side-sheet/formula';
import { isPlainObject } from 'lodash';

export function isFormulaSpec(formula: any): formula is FormulaSpec {
  return isPlainObject(formula) && 'name' in formula && 'args' in formula;
}
